import React, {useEffect, useState} from "react"
import EditIcon from "@mui/icons-material/PhotoCamera"
import Fade from "@mui/material/Fade"
import {isTouchDevice} from "../../lib/util"
import IconButton from "@mui/material/IconButton"
import {useAuth} from "../../hooks/use-auth";
import {useSelector, useDispatch} from "../../store";
import {CoverPhotoPicker} from "./cover-photo-picker";
import {updateCoverUrl} from "../../slices/user-session-slice";
import {Box} from "@mui/material";
import {useTheme} from "@mui/material/styles";

export const ProfileCoverImage = () => {

    const {uid, coverUrl} = useSelector((state) => state.userSession.currentProfile);

    const dispatch = useDispatch()

    const theme = useTheme()

    const {isAuthenticated, user} = useAuth()

    const isAllowedToEdit = user?.uid === uid

    const [showEdit, setShowEdit] = useState(false)
    const [showPicker, setShowPicker] = useState(false)

    useEffect(() => {

        if (isAllowedToEdit && !showEdit && isTouchDevice()) {
            setShowEdit(true)
        }

    }, [isAllowedToEdit])

    const handleMouseEnter = (event: any) => {
        shouldShowEdit()
    }

    const handleMouseLeave = (event: any) => {
        hideEditUnlessTouch()
    }

    const hideEditUnlessTouch = () => {
        if (!isTouchDevice()) {
            setShowEdit(false)
        }
    }

    const shouldShowEdit = () => {
        if (isAllowedToEdit) {
            setShowEdit(true)
        }
    }

    const handleEditClick = (event: any) => {
        setShowPicker(true)
    }

    const handlePhotoCropAndUploadFinished = (url: string | null) => {

        if (isAllowedToEdit && !!url) {
            dispatch(updateCoverUrl(url))
        }
        hideEditUnlessTouch()

        setShowPicker(false)

    }


    return <Box
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
            position: "relative",
            overflow: "hidden",
            height: {
                xs: 150,
                sm: 200,
                md: 315,
                lg: 330,
                xl: 350
            }
        }}
    >

        <img
            src={coverUrl}
            style={{
                width: "100%",
                height: "auto",
                display: "block",
                position: "absolute",
                minHeight: "100%",
                maxHeight: "100%",
                left: 0,
                top: 0,
                objectFit: "cover",
                ...(!isAuthenticated && {
                    filter: "blur(5px) grayscale(100%)"
                }),
            }}

        />

        <Fade mountOnEnter unmountOnExit in={showEdit}>
            <Box
                sx={{
                    position: "absolute",
                    left: theme.spacing(2),
                    top: theme.spacing(2),
                }}
            >
            <IconButton
                onClick={handleEditClick}
                sx={{
                    transition: "all 0.2s ease-out",
                    backgroundColor: "rgba(204,204,204,0.7)",
                    "&:hover": {
                        backgroundColor: "rgba(204,204,204, 1.0)",
                    }
                }}
            >
                <EditIcon/>
            </IconButton>
            </Box>
        </Fade>

        <CoverPhotoPicker open={showPicker} onFinished={handlePhotoCropAndUploadFinished}/>

    </Box>

}

